import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { LocalStorageService } from '@shared/services';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-cacheLoginCreds',
    'templateUrl': './cacheLoginCreds.page.html',
    'styleUrls': ['./cacheLoginCreds.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class CacheLoginCredsPage extends ViewBasePage implements OnInit {
    public vm: any = {};

    constructor(private localStorageService: LocalStorageService, injector: Injector) {
        super(injector);
    }

    public override ngOnInit() {
        this.vm.email = '';
        this.vm.password = '';
    }

    public async onGetClick() {
        const keys = this.getKeys();

        // this.vm.email = await this.storage.get('shuttleNomixLoginEmail');
        // this.vm.password = await this.storage.get('shuttleNomixLoginPassword');

        this.vm.email = await this.localStorageService.get(keys.emailKey);
        this.vm.password = await this.localStorageService.get(keys.passwordKey);
    }

    public async onSetClick() {
        const keys = this.getKeys();

        // this.storage.set('shuttleNomixLoginEmail', this.vm.email);
        // this.storage.set('shuttleNomixLoginPassword', this.vm.password);

        await this.localStorageService.set(keys.emailKey, this.vm.email);
        await this.localStorageService.set(keys.passwordKey, this.vm.password);
    }

    private getKeys(): any {
        const app = this.sessionService.getApp()

        const keys = {
            'emailKey': app + '_shuttleNomixLoginEmail',
            'passwordKey': app + '_shuttleNomixLoginPassword'
        }

        return keys;
    }
}